import { signal } from 'services/SignalsService'

const name = 'AWAIT-POPUP-CONTINUE'

async function execute() {
  game.models.GameModel.showBonusPopupContinue = false
  return signal.promise('BUTTON:continue')
}

export function getAwaitContinueAction() {
  return {
    name,
    execute,
  }
}
